import { useEffect, useState, useRef } from "react"
import Map from "react-map-gl/mapbox"
import ZoomControls from "layouts/station/mapZoom.tsx"
import MapMarkers from "layouts/station/mapMarker.tsx"
import { Card } from "@mui/material"
import MapLegend from "layouts/station/mapLegend.tsx"

import { StationFeature, StationGeojson } from "types/stations"

interface MapPageProps {
    latitude?: number | null
    longitude?: number | null
    chosenStation?: StationFeature | undefined
    geojson?: StationGeojson | undefined
    counter?: number
}
export function StationMap({
    latitude = null,
    longitude = null,
    chosenStation,
    geojson,
    counter,
}: MapPageProps) {
    const mapRef = useRef(null)
    const [viewPosition, setViewPosition] = useState<{
        latitude: number
        longitude: number
        zoom: number
    }>({
        latitude: latitude ?? 47.232193, // Default latitude (France)
        longitude: longitude ?? 2.209667, // Default longitude (France)
        zoom: longitude && latitude ? 15 : 5.3,
    })

    useEffect(() => {
        console.log(geojson)
    }, []);

    useEffect(() => {
        if (chosenStation && mapRef.current) {
            // Utilisez les coordonnées depuis geometry.coordinates
            // Note: GeoJSON utilise [longitude, latitude]
            const [longitude, latitude] = chosenStation.geometry.coordinates

            // @ts-expect-error because the type of mapRef is not the same as the one expected by flyTo
            mapRef.current.flyTo({
                center: [longitude, latitude],
                zoom: 15,
            })
        }
    }, [chosenStation, counter])

    useEffect(() => {
        async function getUserLocation() {
            return new Promise((resolve) => {
                const defaultLocation = {
                    lat: 47.232193,
                    lng: 2.209667,
                }

                if ("geolocation" in navigator) {
                    navigator.geolocation.getCurrentPosition(
                        (position: GeolocationPosition) => {
                            const location = {
                                latitude: latitude ?? position.coords.latitude,
                                longitude:
                                    longitude ?? position.coords.longitude,
                                zoom: 15,
                            }
                            setViewPosition(location)
                            resolve(location)
                        },
                        () => {
                            resolve(defaultLocation)
                        }
                    )
                } else {
                    setViewPosition({
                        latitude: latitude ?? defaultLocation.lat,
                        longitude: longitude ?? defaultLocation.lng,
                        zoom: 5.3,
                    })
                    resolve(defaultLocation)
                }
            })
        }

        getUserLocation()
    }, [latitude, longitude])

    return (
        <Card
            variant="outlined"
            style={{
                width: "100%",
                height: "100%",
                borderRadius: "25px",
                position: "relative",
            }}
        >
            <Map
                mapboxAccessToken={import.meta.env.VITE_MAPBOX_KEY}
                {...viewPosition}
                ref={mapRef}
                onMove={(evt) => setViewPosition(evt.viewState)}
                attributionControl={false}
                mapStyle="mapbox://styles/fquene/clr9316op004201r5e51j6gmv"
                projection={{ name: "globe" }}
            >
                <MapLegend geojson={geojson as StationGeojson} />
                <ZoomControls setViewPosition={setViewPosition} />
                <MapMarkers geojson={geojson} />
            </Map>
        </Card>
    )
}
